/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForSplitGoodsInfoForSplitVo } from './OrderInfoForSplitGoodsInfoForSplitVo';
import {
    OrderInfoForSplitGoodsInfoForSplitVoFromJSON,
    OrderInfoForSplitGoodsInfoForSplitVoFromJSONTyped,
    OrderInfoForSplitGoodsInfoForSplitVoToJSON,
    OrderInfoForSplitGoodsInfoForSplitVoToJSONTyped,
} from './OrderInfoForSplitGoodsInfoForSplitVo';

/**
 * 
 * @export
 * @interface OrderInfoForSplitVo
 */
export interface OrderInfoForSplitVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    id?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    orderCode?: string;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    requestTypeName?: string;
    /**
     * 结算方式
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    paymentTypeName?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    warehouseName?: string;
    /**
     * 国际运输方式
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    internationalTransportMethodName?: string;
    /**
     * 接收人姓名
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    receiverName?: string;
    /**
     * 包裹数量
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    parcelCount?: number;
    /**
     * 包裹数量-入库数量
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    parcelWarehouseCount?: number;
    /**
     * 商品数量
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    goodsCount?: number;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    goodsTotalAmountCny?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof OrderInfoForSplitVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 所有快递货位位置
     * @type {Array<string>}
     * @memberof OrderInfoForSplitVo
     */
    locations?: Array<string>;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    orderStatusName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof OrderInfoForSplitVo
     */
    updateTime?: string;
    /**
     * 商品列表
     * @type {Array<OrderInfoForSplitGoodsInfoForSplitVo>}
     * @memberof OrderInfoForSplitVo
     */
    goodsList?: Array<OrderInfoForSplitGoodsInfoForSplitVo>;
}

/**
 * Check if a given object implements the OrderInfoForSplitVo interface.
 */
export function instanceOfOrderInfoForSplitVo(value: object): value is OrderInfoForSplitVo {
    return true;
}

export function OrderInfoForSplitVoFromJSON(json: any): OrderInfoForSplitVo {
    return OrderInfoForSplitVoFromJSONTyped(json, false);
}

export function OrderInfoForSplitVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForSplitVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'paymentTypeName': json['paymentTypeName'] == null ? undefined : json['paymentTypeName'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'parcelCount': json['parcelCount'] == null ? undefined : json['parcelCount'],
        'parcelWarehouseCount': json['parcelWarehouseCount'] == null ? undefined : json['parcelWarehouseCount'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'goodsTotalAmountCny': json['goodsTotalAmountCny'] == null ? undefined : json['goodsTotalAmountCny'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoFromJSON)),
    };
}

export function OrderInfoForSplitVoToJSON(json: any): OrderInfoForSplitVo {
    return OrderInfoForSplitVoToJSONTyped(json, false);
}

export function OrderInfoForSplitVoToJSONTyped(value?: OrderInfoForSplitVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderCode': value['orderCode'],
        'requestTypeName': value['requestTypeName'],
        'paymentTypeName': value['paymentTypeName'],
        'warehouseName': value['warehouseName'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'receiverName': value['receiverName'],
        'parcelCount': value['parcelCount'],
        'parcelWarehouseCount': value['parcelWarehouseCount'],
        'goodsCount': value['goodsCount'],
        'goodsTotalAmountCny': value['goodsTotalAmountCny'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'locations': value['locations'],
        'orderStatusName': value['orderStatusName'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoToJSON)),
    };
}

